import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../stores/auth-store'
import { useProjectsStore } from '../stores/projects-store'

import AppLayout from '../layouts/AppLayout.vue'
import AuthLayout from '../layouts/AuthLayout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'projects' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'projects' },
    children: [
      {
        name: 'channels',
        path: 'channels',
        component: () => import('../pages/channels/ChannelsPage.vue'),
      },
      {
        name: 'projects',
        path: 'projects',
        component: () => import('../pages/projects/ProjectsPage.vue'),
      },
      {
        name: 'emails',
        path: 'emails',
        component: () => import('../pages/emails/EmailsPage.vue'),
      },
      {
        name: 'logs',
        path: 'logs',
        component: () => import('../pages/email-history/LogsPage.vue'),
      },
      {
        name: 'push-template-errors',
        path: 'push-template-errors',
        component: () => import('../pages/push-template-errors/PushTemplateErrorsPage.vue'),
      },
      {
        name: 'admin-users',
        path: 'admin/users',
        component: () => import('../pages/admin/AdminUsersPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'change-password',
        path: 'change-password',
        component: () => import('../pages/auth/ChangePassword.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

export default router
